import React from "react";

import { Media } from "../../../components/Media/Media";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default function MediaBlockElement(props) {
    const { mediaElement, withGallery } = props;

    if (!mediaElement.media) return null;

    return (
        <>
            <Media
                mediaElement={mediaElement}
                videoControls={true}
                gridDisable
                withGallery={withGallery}
                showDescription={false}
            />
        </>
    );
}
